import React, { ReactElement, useMemo } from "react";
import { Box, LinearProgress, SxProps } from "@mui/material";
import { merge } from "lodash";

export interface MuiStructuralChartContainerProps {
  children: ReactElement<{ width: number; height: number }> | false;
  loading?: boolean;
  sx?: SxProps;
}

export const MuiStructuralChartContainer = React.forwardRef<
  HTMLDivElement,
  MuiStructuralChartContainerProps
>((props, ref) => {
  const loading = props.loading ?? false;
  const sx = useMemo(() => {
    return merge(
      {
        position: "relative",
        display: "flex",
        flexDirection: "column",
      },
      props.sx
    );
  }, [props.sx]);

  return (
    <Box ref={ref} className={"MuiChartContainer"} sx={sx}>
      <>
        {loading && (
          <LinearProgress
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
            }}
          />
        )}
        {props.children !== false && props.children}
      </>
    </Box>
  );
});
